var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoomBooking = function SvgRoomBooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.948 0v1.118h3.77V16.49h1.527a.755.755 0 0 1 0 1.51h-3.004V2.634h-2.293V18H.755a.755.755 0 1 1 0-1.51H2.3V0zm-8.17 1.516V16.49h6.687V1.516zm4.39 6.55q.395 0 .653.268c.174.18.262.4.262.67q0 .4-.262.668a.87.87 0 0 1-.656.269.88.88 0 0 1-.655-.27.92.92 0 0 1-.263-.668q0-.402.263-.669a.88.88 0 0 1 .657-.269"
  })));
};
export default SvgRoomBooking;